import { Component, input } from '@angular/core';

/**
 * One day's worth of stock for the at-a-glance cell. `stock` and `capacity` are `null` when the
 * establishment holds no row for that day, which reads as "no row" rather than sold out.
 */
export interface StockDayCell {
  /** Short weekday label, e.g. `Tue`. */
  label: string;
  stock: number | null;
  capacity: number | null;
}

/**
 * The three-day stock glance shown per menu item on the producer's list: a small bar filled by
 * remaining ÷ capacity plus the remaining number, for today and the next two days. A `null` days input
 * means the item is not offered, so there is no stock to show.
 */
@Component({
  selector: 'app-inventory-stock-cell',
  standalone: true,
  templateUrl: './inventory-stock-cell.html',
  styleUrl: './inventory-stock-cell.scss'
})
export class InventoryStockCell {
  readonly days = input.required<StockDayCell[] | null>();

  fillPercent(day: StockDayCell): number {
    if (day.stock === null || day.capacity === null || day.capacity <= 0) {
      return 0;
    }
    return Math.max(0, Math.min(100, Math.round((day.stock / day.capacity) * 100)));
  }

  fillClass(day: StockDayCell): string {
    if (day.stock === null) return 'fill-none';
    if (day.stock === 0) return 'fill-lo';
    return this.fillPercent(day) >= 50 ? 'fill-hi' : 'fill-mid';
  }
}
